import { Navigate, Route, Routes } from 'react-router-dom';

import type { Route as AppRoute } from '@api/app_context/types';

import Tabs from '../../layouts/Tabs';

import { getDashboardsPage } from './utilities/helpers';

const Dashboards = ({ route }: { route: AppRoute }) => (
  <Tabs route={route}>
    <Routes>
      {route.routes?.map((route) => (
        <Route element={getDashboardsPage(route)} key={route.id} path={route.path} />
      ))}
      <Route element={<Navigate replace to={route.routes[0]?.path} />} path="*" />
    </Routes>
  </Tabs>
);

export default Dashboards;
